import React from 'react';
import {
  ShieldOutlined as ShieldIcon,
  LayersOutlined as IsolationIcon,
  AdminPanelSettingsOutlined as AccessIcon,
  LockOutlined as EncryptIcon,
  KeyOutlined as SsoIcon,
  VisibilityOffOutlined as PrivacyIcon,
  GavelOutlined as ComplianceIcon,
  HistoryToggleOffOutlined as ContinuityIcon,
} from '@mui/icons-material';
import { BRAND, BottomCta, usePageMeta } from './shared';

const TRUST = [
  { Icon: ShieldIcon, t: 'Privacy by design', d: 'Privacy and access controls are built into the core of the platform—not bolted on. Members decide what they share, and organizations decide who sees it.' },
  { Icon: IsolationIcon, t: 'Multi-tenant isolation', d: 'Every organization’s data is logically separated and scoped, so one community’s information is never exposed to another.' },
  { Icon: AccessIcon, t: 'Role-based access', d: 'Granular roles across members, chapters, regions, and national leadership ensure people only see and do what they should.' },
  { Icon: EncryptIcon, t: 'Encryption & safeguards', d: 'Data is encrypted in transit, with administrative and technical safeguards designed to protect member information.' },
  { Icon: SsoIcon, t: 'Authentication & SSO', d: 'Secure sign-in with verification, and Single Sign-On so members use your organization’s existing identity provider.' },
  { Icon: PrivacyIcon, t: 'Member-controlled visibility', d: 'Directory visibility, profile details, and contactability are controlled by members and your organization’s policies.' },
  { Icon: ComplianceIcon, t: 'Compliance-minded', d: 'We handle data responsibly and support member rights to access and removal, working with each organization as the data controller.' },
  { Icon: ContinuityIcon, t: 'Built for continuity', d: 'Reliable, monitored infrastructure keeps your community’s home available—today and for generations to come.' },
];

const Security: React.FC = () => {
  usePageMeta('Security & Privacy');
  return (
    <>
      <section className="page-head">
        <div className="container">
          <h1>Security &amp; privacy by design.</h1>
          <p>Your members’ trust is the foundation of everything you do. {BRAND} is built to protect their data, their identities, and your organization’s legacy.</p>
        </div>
      </section>

      <section className="page-body">
        <div className="container">
          <div className="grid-3">
            {TRUST.map(({ Icon, t, d }) => (
              <div className="feature-lg" key={t}>
                <div className="gold-coin"><Icon style={{ fontSize: 24 }} aria-hidden="true" /></div>
                <h3>{t}</h3>
                <p>{d}</p>
              </div>
            ))}
          </div>

          <div className="prose" style={{ marginTop: 44 }}>
            <h2>How data is controlled</h2>
            <p>
              When an organization runs on {BRAND}, that organization is the controller of its
              members’ data and sets the policies that govern it. We act as a service provider,
              processing data on the organization’s behalf and giving leaders the controls to manage
              access, visibility, and retention.
            </p>
            <p>
              Have a security or privacy question for your rollout? We’re happy to walk through the
              details with your team.
            </p>
          </div>
        </div>
      </section>

      <BottomCta title="Talk through security for your organization." />
    </>
  );
};

export default Security;
